<style lang="scss"></style>

<template>
  <div>
    <div>
      <b-row>
        <b-col cols="12">
          <label>Name</label>
          <b-form-input class="mb-1"
            required
            label="Name" cy="name"
            placeholder="Enter name"
            v-model="restrictedDate.name">
          </b-form-input>
        </b-col>
        <b-col cols="6">
          <label>Start Date</label>
          <b-form-datepicker
            @input="restrictedDate.end_date = null"
            label="Start Date" cy="start-date"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            v-model="restrictedDate.start_date">
          </b-form-datepicker>
        </b-col>
        <b-col cols="6">
          <label>End Date</label>
          <b-form-datepicker
            label="End Date" cy="end-date"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            :min="restrictedDate.start_date"
            v-model="restrictedDate.end_date">
          </b-form-datepicker>
        </b-col>
        <b-col cols="12" class="mt-1">
          <label>Reason</label>
          <b-form-textarea
            label="Reason" cy="reason"
            placeholder="Enter reason"
            rows="4"
            v-model="restrictedDate.reason">
          </b-form-textarea>
        </b-col>
      </b-row>

      <section class="d-flex full-width mt-4">
        <div class="ui-spacer"></div>
        <button class="btn btn-danger mr-2" @click="$emit('close', true)">Cancel</button>
        <button class="btn btn-primary" :class="{'disabled' : submitting || !isValid()}" @click="addDate()">Add
          Restricted Date
        </button>
      </section>

    </div>
  </div>
</template>

<script>
import BookingRestrictedDateService from '../../../services/BookingRestrictedDateService';

export default {
  props: {},
  components: {},
  data() {
    return {
      restrictedDate: {
        name: '',
        start_date: '',
        end_date: '',
        reason: '',
      },
      submitting: false,
    };
  },
  mounted() {
  },
  methods: {
    addDate() {
      if (this.isValid()) {
        this.submitting = true;

        BookingRestrictedDateService.addRestrictedDate(this.restrictedDate).then(() => {
          this.$toast.success('Restricted Date successfully added', {
            toastClassName: ['toast-std', 'success-toast'],
          });
          this.$emit('refresh', true);
        }).catch((err) => {
          let message = 'Error creating the restricted Date, please try again';

          if (err.response && err.response.data && err.response.data.error === 'ENTITY_ALREADY_EXISTS') {
            message = 'Restricted Date already exists, please choose another';
          }
          this.$toast.error(message, {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        }).finally(() => {
          this.submitting = false;
        });
      }
    },
    isValid() {
      const name = this.restrictedDate.name.length > 0;
      const start = this.restrictedDate.start_date && this.restrictedDate.start_date.length > 0;
      const end = this.restrictedDate.end_date && this.restrictedDate.end_date.length > 0;

      return name && start && end;
    }
  },
};
</script>
